export default __webpack_public_path__ + "static/media/Йод_1л.9d8cb23e.jpg";